<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="16">
            <el-input placeholder="输入船东信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>
          </el-col>
        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100">
            <!-- 客户名称 -->
            <el-table-column align="left" label="会员名称" min-width="120px">
              <template slot-scope="scope">
                <span v-if="$perm(['customer.view_customer'])" class="font-weight-bold text-link"
                      @click="handleUpdate(scope.row.id)">{{scope.row.name}}</span>
                <span v-else class="font-weight-bold">{{scope.row.name}}</span>
                <span class="badge ml-2" :class="scope.row.type === '0' ? 'badge-success' : 'badge-warning'">{{ scope.row.type_name }}</span>
              </template>
            </el-table-column>
            <!-- 固定电话 -->
            <!-- <el-table-column align="left" label="电话">
              <template slot-scope="scope">
                <span>{{scope.row.phone}}</span>
              </template>
            </el-table-column> -->
            <!-- 手机号码 -->
            <!-- <el-table-column align="left" label="手机">
              <template slot-scope="scope">
                <span>{{scope.row.mobile}}</span>
              </template>
            </el-table-column> -->
            <!-- 邮箱 -->
            <el-table-column align="left" label="邮箱">
              <template slot-scope="scope">
                <span>{{scope.row.email}}</span>
              </template>
            </el-table-column>
            <!-- 更新人 -->
            <el-table-column align="left" label="更新人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column>
            <!-- 创建时间 -->
            <el-table-column align="left" label="创建时间">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>
            <!-- 数据完整度 -->
            <el-table-column align = "left" label = "数据完整度">
              <template slot-scope = "scope">
                <span :style="{'color': completeness(scope.row)<30? 'red': completeness(scope.row)>70? 'green':'blue'}"> 
                  <!-- 完成率<30%(红色);完成率>70%(绿色);其他(蓝色) -->
                  {{ completeness(scope.row) }}%
                </span>
              </template>
            </el-table-column>
            <!-- 证书识别状态 -->
            <!-- <el-table-column align="left" label="证书状态">
              <template slot-scope="scope">
                <el-popover :disabled="scope.row.cert_status==='0' || scope.row.cert_status==='1'"
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content=scope.row.cert_msg>
                  <span class="badge mr-1" :class="getCertStatusBadge(scope.row.cert_status)" slot="reference">{{ scope.row.cert_status_name }}</span>
                </el-popover>
              </template>
            </el-table-column> -->
            <!-- 按钮组 -->
            <el-table-column align="left" label="操作">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start" content="编辑">
                    <el-button type="text" @click="handleUpdate(scope.row.id)" ><svg-icon icon-class="edit"></svg-icon></el-button>
                </el-tooltip>
                <!-- <el-tooltip effect="light" content="审核" placement="top-start">
                <el-button type="text" class="pr-1" @click="handleSuccess(scope.row)">
                    <i class="el-icon-document-checked"></i>
                </el-button> -->
                <!-- </el-tooltip> -->
              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
        </div>
      </el-card>
      <member-upload-cert-dialog ref="CustomerUploadCert">
      </member-upload-cert-dialog>
    </div>
  
  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import { getCertStatusBadge } from '@/utils/customer'
    import MemberUploadCertDialog from './member-upload-cert-dialog'
    import {getMemberList,deleteMember} from '@/api/member'
  
    export default {
      name: "applyList",
      components: {
        PaginationNew,
        MemberUploadCertDialog
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          query: {
            search: '',
            offset: 0,
            limit: 20,
            updater: '',
            status:4
          },
          searching: false,
          listLoading: false,
          loadingText: '正在加载船东数据，请稍等...',
          list: [],
          total: 0,
          updaterList: [],
        }
      },
      methods: {
        handleSuccess(row) {
            this.$router.push({ name: 'memberUpdate', query: {'type': 'SuccessApply', 'id': row.id}})
            },
        setQueryStorage() {
            window.localStorage.setItem('query', JSON.stringify(this.query))
          },
        getCertStatusBadge,
        handleSearch() {
          this.getList()
        },
        handleUpdate(id) {
          this.setQueryStorage()
          this.$router.push({name: 'memberUpdate', query: {'type':'QuitMember',id: id}})
        },
        handleDelete(customer) {
          var msg = '是否删除客户 ' + customer.name + ' ？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            deleteMember(customer.id)
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.getList()
              })
              .catch(error => {
                this.$message.error(error)
              })
          })
        },
        getList() {
          // 从数据库中加载用户数据
          this.listLoading = true
          getMemberList(this.query)
            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
              window.localStorage.removeItem('query')
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
        completeness(data) {
          var cn = 0
          var key_list = ['address', 'cert_number', 'cert_type', 'contact', 'contact_mobile', 
                      'email', 'mobile', 'name', 'phone', 'site']
          for (var key in data){
            if ((key_list.indexOf(key) > -1) && (data[key] !== null) && (data[key] !== "")) {
              cn += 1
            }
            else if (key == "ext_info"){
              var ext_info = data[key]
              for (var k in ext_info) {
                if (k == "tag_list") {
                  if (ext_info[k].length !== 0) {
                    cn += 1
                  }
                } else if ((ext_info[k] !== null) && (ext_info[k] !== "")) {
                  cn += 1
                }
              }
              // cn += Object.getOwnPropertyNames(data[key]).length - 1 
            }
          }
  
          var completeness = (cn / 10 * 100).toFixed(0)
          if (completeness > 100){ completeness = 100 }
          return completeness
        },
      },
      created() {
        this.query = JSON.parse(window.localStorage.getItem('query')) || {
            search: '',
            offset: 0,
            limit: 20,
            updater: '',
            status:4
            
          }
        this.getList()
      }
    }
  </script>
  